var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var _a;
import { createSlice } from "@reduxjs/toolkit";
var initialStateValue = {
    firstname: '',
    lastname: '',
    email: '',
    email_confirmation: '',
    password: '',
    password_confirmation: '',
    phone: '',
    billingAddress: '',
    billingCity: '',
    billingState: '',
    country: '',
    billingZip: '',
    billingApartment: '',
    paymentMethodId: '',
    skipCard: false,
    readTermConditions: false,
    readPolicy: false,
    phonemsg: false,
};
export var registerUserSlice = createSlice({
    name: "registerUser",
    initialState: { value: initialStateValue },
    reducers: {
        save: function (state, action) {
            state.value = __assign(__assign({}, state.value), action.payload);
        },
        reset: function (state) {
            state.value = initialStateValue;
        }
    }
});
export var save = (_a = registerUserSlice.actions, _a.save), reset = _a.reset;
export default registerUserSlice.reducer;
